import React from 'react'
import { Button, Card, Image, Row } from 'react-bootstrap'

import TicketIcon from '../../../assets/icons/sidebar/ticket.svg'
import { useSelector } from 'react-redux'
import CardColumn from './CardColumn'
import ModalX from '../../../components/others/ModalX'
import TicketDetails from '../../ticket/pages/TicketDetails'
import TableAction from '../../ticket/components/TableAction'
import { SERVER_URL } from '../../../config'

function CardElement({ icon = undefined, data, page, title }) {
  const { token } = useSelector((state) => state.auth)
  const [isOpen, setIsOpen] = React.useState(false)
  const InvoiceElements = ({ total, printId }) => {
    const PrintBtn = () => {
      return (
        <Button
          variant='success'
          className='text-white btn-sm'
          onClick={() => downloadInvoice(data?.billing_details?.billing_id)}
        >
          Print Invoice
        </Button>
      )
    }

    return (
      <>
        <CardColumn size_mid={2} column_name='Total' element={total} />
        <CardColumn size_mid={2} column_name='Print' element={<PrintBtn />} />
      </>
    )
  }

  const downloadInvoice = async (billing_id) => {
    try {
      const response = await fetch(SERVER_URL + 'invoice/download-pdf', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify({ billing_id }), // Sending invoiceId in the request body
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const blob = await response.blob() // Get the response as a blob
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'invoice.pdf') // Set the filename
      document.body.appendChild(link)
      link.click() // Programmatically click the link to trigger the download
      document.body.removeChild(link) // Clean up
    } catch (error) {
      console.error('Error downloading invoice:', error)
      // Handle error (e.g., show a notification)
    }
  }

  return (
    <Card className='w-100 shadow-basic border-1 mb-2'>
      <Card.Body className='d-flex align-items-center'>
        <Image src={icon ?? TicketIcon} />
        <span style={{ marginLeft: '10px', fontSize: '14px' }}>
          {/* Dummy-Ticket-ID */}
         {title}
        </span>
      </Card.Body>

      <Card.Body className=''>
        <Row>
          <CardColumn
            size_mid={page == 'ticket' ? 3 : 2}
            column_name='Ticket Id'
            element={data.ticket_no}
          />
          <CardColumn size_mid={2} column_name='Issue' element={data.issue} />
          <CardColumn
            size_mid={2}
            column_name='Status'
            element={data.status ? data.status : ''}
          />
          <CardColumn size_mid={2} column_name='Date' element={data.date} />
          {page == 'ticket' ? (
            <CardColumn
              size_mid={3}
              column_name='Actions'
              element={<TableAction data={data} />}
            />
          ) : (
            <InvoiceElements total={data?.total_cost} printId={1} />
          )}
          <ModalX isOpen={isOpen} toggle={() => setIsOpen(false)} size='xl'>
            <TicketDetails type='modal' id={data.ticket_id} />
          </ModalX>
        </Row>
      </Card.Body>
    </Card>
  )
}

export default CardElement
